'use client';

import { useState, useEffect } from 'react';
import Script from 'next/script';

// Cookie name must match the one in CookieConsent.tsx
const COOKIE_NAME = "cookie_consent";

export default function Analytics() {
  const [consentGiven, setConsentGiven] = useState<string | null>(null);

  useEffect(() => {
    // Function to check consent from cookies
    const checkConsent = () => {
      const consentCookie = document.cookie
        .split("; ")
        .find((c) => c.startsWith(`${COOKIE_NAME}=`));
      
      if (consentCookie) {
        const consentValue = consentCookie.split("=")[1];
        setConsentGiven(consentValue);
        return consentValue;
      }
      return null;
    };
    
    // Initial check
    checkConsent();
    
    // Set up interval to periodically check consent
    // This ensures analytics is loaded if consent is given in another tab or after page refresh
    const intervalId = setInterval(checkConsent, 2000);
    
    // Listen for changes to consent (real-time updates within the same session)
    const handleConsentChange = (e: Event) => {
      const customEvent = e as CustomEvent;
      if (customEvent.detail?.value) {
        setConsentGiven(customEvent.detail.value);
      } else {
        checkConsent();
      }
    };
    
    window.addEventListener('consentChanged', handleConsentChange);
    
    return () => {
      window.removeEventListener('consentChanged', handleConsentChange);
      clearInterval(intervalId);
    };
  }, []);

  // Only render analytics scripts if consent is "all"
  if (consentGiven !== "all") {
    return null;
  }

  return (
    <>
      {/* Google Analytics */}
      <Script 
        strategy="afterInteractive"
        src="https://www.googletagmanager.com/gtag/js?id=G-97N2GSR52L"
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-97N2GSR52L');
            console.log('Google Analytics initialized');
          `,
        }}
      />

      {/* Microsoft Clarity */}
      <Script
        id="microsoft-clarity"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                console.log('Microsoft Clarity initialized');
            })(window, document, "clarity", "script", "mtzdkr6x9m");
          `,
        }}
      />
    </>
  );
} 